import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const CardSkeleton = () => {
  return (
    <Card
      sx={{
        boxShadow: 5,
        display: 'flex',
        flexDirection: 'column',
        margin: 1,
        minHeight: 234,
        padding: 1,
      }}
    >
      <Stack
        spacing={2}
        sx={{
          flexGrow: 1,
        }}
      >
        <Skeleton height={50} />
        <Skeleton height={2} />
        <Skeleton height={50} />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Box
          sx={{
            alignItems: 'center',
            borderRadius: 16,
            display: 'flex',
            justifyContent: 'center',
            my: 1,
          }}
        >
          <Skeleton
            height={60}
            sx={{
              borderRadius: 25,
              mx: 1,
            }}
            width={110}
          />
          <Skeleton
            height={60}
            sx={{
              borderRadius: 25,
              mx: 1,
            }}
            width={110}
          />
        </Box>
      </Stack>
    </Card>
  );
};

export default CardSkeleton;
